import { UiDetailExpandedComponent } from "../components/detail-expanded/detail-expanded.component";
import { UiTableCellActionComponent } from "../components/table-cell-action/table-cell-action.component";
import { ACTION_CELL_COMPONENT, DETAIL_COMPONENT } from "../token/detail-token";

export const DEFAULT_PROVIDERS = [
  { provide: DETAIL_COMPONENT, useValue: UiDetailExpandedComponent },
  {
    provide: ACTION_CELL_COMPONENT,
    useValue: UiTableCellActionComponent,
  },
];
